/*
 * @Descripttion: 
 * @Author: KevinYoung
 * @Date: 2020-09-27 10:15:30
 * @LastEditors: KevinYoung
 * @LastEditTime: 2020-09-27 10:39:50
 */
export const connectConfig = {
    //singal_server: "ws://ebox.vrmaker.com.cn:8124/",
    //singal_server: "ws://192.168.33.170:7000/observer/",
    singal_server: "ws://ebox.vrmaker.com.cn:7000/observer/",
    turn_server: [
        {
            urls: ["turn:local.vrmaker.vip:3478"],
            //urls: ["turn:220.249.101.248:3478"],
            "username":"maker",
            "credential":"maker2016"
        },
        {
            urls:["stun:stun.l.google.com:19302"]
            //urls:["stun:stun.ekiga.com:3478"]
        }
    ],
    roomName: window.roomName,
    //roomName: 'CHDiscern2',
    //roomName: 'CHVisible',
    //roomName: 'CHHot',
    //roomName: 'CHLobby',
    //roomName: '777',
}


//运行命令： npm run start
//视频房间:
// 凯骏:'KJMain'
//"可见光":"CHVisible"
// "热成像":"CHHot"
// "走廊监控":"CHLobby"
// "展厅":"CHDiscern"